import { render, staticRenderFns } from "./videoNumberGoods.vue?vue&type=template&id=1071e930&scoped=true&"
import script from "./videoNumberGoods.vue?vue&type=script&lang=js&"
export * from "./videoNumberGoods.vue?vue&type=script&lang=js&"
import style0 from "./videoNumberGoods.vue?vue&type=style&index=0&id=1071e930&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1071e930",
  null
  
)

export default component.exports